module.exports = __webpack_public_path__ + "img/rotate_button.0b6e7887.svg";